import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Footer } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { IssueCard } from "../../../IssueCard/IssueCard";

const IssueCardList = memo(({ attempt }) => (
  <>
    {attempt.issues.map((issue, index) => (
      <IssueCard
        data-testId={`IssueCardList-Item-${index}`}
        key={`issue_card_${attempt.assignment.assignmentNumber}_${index}`}
        cardBgColor="white"
        issue={issue}
      />
    ))}
  </>
));

export const AssignmentReview = ({ attempt, onClose }) => {
  const { attemptNumber } = attempt;
  const { assignmentNumber } = attempt.assignment;
  const { classes } = useStyles();

  const displayWoNumberWithAttempt = `${assignmentNumber}-${
    attemptNumber > 9 ? attemptNumber : `0${attemptNumber || 0}`
  }`;

  return (
    <Box className={classes.root}>
      <Box flex={1}>
        <Box className={classes.assignmentCard}>
          <Box className={classes.assignmentTitle}>
            <MiIcon
              className={classes.assignmentTitleIcon}
              path={mdi.mdiTools}
              size={0.75}
              color="white"
            />
            New Assignment: #{displayWoNumberWithAttempt}
            <Box className={classes.newBadge}>New</Box>
          </Box>
          <IssueCardList attempt={attempt} />
        </Box>
      </Box>
      <Footer
        show
        actions={[
          {
            name: "Close",
            variant: BUTTON_VARIANTS.TEXT,
            color: BUTTON_COLORS.BLACK,
            onClick: onClose,
          },
        ]}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  assignmentCard: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 4,
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.orange.light,
    border: `1px solid ${theme.palette.orange.main}`,
    marginTop: theme.spacing(2),
  },
  assignmentTitle: {
    display: "flex",
    alignItems: "center",
    margin: `${theme.spacing(2)} 0`,
    ...theme.typography.body2,
    fontWeight: theme.typography.fontWeightBold,
  },
  assignmentTitleIcon: {
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.orange.main,
    padding: theme.spacing(1),
    borderRadius: "50%",
  },
  newBadge: {
    backgroundColor: theme.palette.orange.medium,
    border: `1px solid ${theme.palette.orange.main}`,
    fontSize: theme.fontSize.small,
    fontWeight: theme.fontWeight.medium,
    color: theme.palette.white.main,
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    marginLeft: theme.spacing(1),
    borderRadius: 4,
  },
}));
